/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type IncreaseCreditRequest = {
    ownerId: string;
    ownerType: IncreaseCreditRequest.ownerType;
    amount: number;
    notes?: string;
};
export namespace IncreaseCreditRequest {
    export enum ownerType {
        SHOP = 'SHOP',
        REVENUE = 'REVENUE',
        THIRD_PARTY = 'THIRD_PARTY',
        CLEARING = 'CLEARING',
        BANKS = 'BANKS',
        FINANCIER = 'FINANCIER',
    }
}

